import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppConfiguration {
  constructor(private httpClient: HttpClient){

  }

  apiUrl: string;
  appName: string;

  ensureInit(): Promise<any> {
    return new Promise((r, e) => {

      this.httpClient.get('~/../assets/conf/config.json')
        .subscribe(
        (content: AppConfiguration) => {

          Object.assign(this, content);
          r(this);
        },
        reason => e(reason));
    });
  }
}
